import React, { FC } from 'react';
import { useQuery } from 'react-query';
import { ProjectAPI } from 'api/project';
import { GENERAL_API_STALE } from 'config/query-config';
import { DEFAULT_SQUAD, SquadContext } from 'contexts/squad';

interface SquadProviderProps {
  projectId: number;
}

export const SquadProvider: FC<SquadProviderProps> = (props) => {
  const { children, projectId } = props;
  const { data, isLoading } = useQuery(
    ['project-members', projectId],
    () => {
      return ProjectAPI.getMembers(projectId);
    },
    { staleTime: GENERAL_API_STALE },
  );

  return (
    <SquadContext.Provider value={data || DEFAULT_SQUAD}>
      {!isLoading && children}
    </SquadContext.Provider>
  );
};
